import { render } from "./Cost_Intro.vue?vue&type=template&id=05335ec1&scoped=true"
import script from "./Cost_Intro.vue?vue&type=script&lang=js"
export * from "./Cost_Intro.vue?vue&type=script&lang=js"

import "./Cost_Intro.vue?vue&type=style&index=0&id=05335ec1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05335ec1"]])

export default __exports__